import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone } from "lucide-react";
import { NAV_LINKS, PEOPLE } from "@/data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-brand-cream/90 backdrop-blur-xl border-b border-brand-line shadow-sm" : "bg-brand-choc/25 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-12 py-2 flex flex-col gap-1 md:flex-row md:items-center md:justify-between md:py-0 md:h-20 md:gap-4">
        <div className="flex items-center justify-between md:justify-start md:shrink-0">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
            <span className="flex items-center rounded-lg bg-white/90 px-2 py-1 shadow-[0_0_22px_rgba(255,255,255,0.35)] ring-1 ring-white/70">
              <img src="images/nbs_logo_v2.png" alt="NBS National logo" className="h-9 md:h-12 w-auto" />
            </span>
          </Link>
          <a
            href={`tel:${PEOPLE[0].tel}`}
            data-testid="header-call-button"
            className="md:hidden inline-flex items-center gap-2 rounded-full bg-brand-red px-4 py-2 text-[12px] font-bold text-brand-cream"
          >
            <Phone className="h-3.5 w-3.5" /> Talk to us
          </a>
        </div>

        <nav
          className="no-scrollbar flex items-center gap-5 overflow-x-auto py-1 md:py-0 lg:gap-7"
          data-testid="main-nav"
        >
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `relative whitespace-nowrap text-[12px] lg:text-[13px] font-bold tracking-wide transition-colors hover:text-brand-gold ${
                  isActive ? "text-brand-gold" : scrolled ? "text-brand-ink" : "text-brand-cream"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={`tel:${PEOPLE[0].tel}`}
            data-testid="header-call-desktop"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brand-red px-5 py-2.5 text-[13px] font-bold text-brand-cream transition-colors duration-300 hover:bg-brand-choc"
          >
            <Phone className="h-3.5 w-3.5" /> Talk to us
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
